var ESubscriptionStatus = /*#__PURE__*/function (ESubscriptionStatus) {
  ESubscriptionStatus["Active"] = "active";
  ESubscriptionStatus["CancellationPending"] = "cancellationPending";
  ESubscriptionStatus["Canceled"] = "canceled";
  ESubscriptionStatus["Revoked"] = "revoked";
  return ESubscriptionStatus;
}(ESubscriptionStatus || {});
var ESubscriptionCancellationReason = /*#__PURE__*/function (ESubscriptionCancellationReason) {
  ESubscriptionCancellationReason["ProductIssue"] = "productIssue";
  ESubscriptionCancellationReason["BetterAlternativeFound"] = "betterAlternativeFound";
  ESubscriptionCancellationReason["TooExpensive"] = "tooExpensive";
  ESubscriptionCancellationReason["NoNeedAnymore"] = "noNeedAnymore";
  ESubscriptionCancellationReason["PaymentFailed"] = "paymentFailed";
  ESubscriptionCancellationReason["Unknown"] = "unknown";
  return ESubscriptionCancellationReason;
}(ESubscriptionCancellationReason || {});
export { ESubscriptionStatus, ESubscriptionCancellationReason };